const translations: Record<string, string> = {
  "ak_bud_month": "Місяць",
  "ak_bud_year": "Рік",
  "ak_bud_accuracy": "Точність",
  "ak_bud_cash": "Каса",
  "ak_bud_low": "Низький",
  "ak_bud_base": "Базовий",
  "ak_bud_high": "Високий",
  "ak_bud_draft": "Чернетка",
  "ak_bud_final": "Фінал",
  "ak_bud_jan": "січ",
  "ak_bud_feb": "лют",
  "ak_bud_mar": "бер",
  "ak_bud_apr": "кві",
  "ak_bud_may": "тра",
  "ak_bud_jun": "чер",
  "ak_bud_jul": "лип",
  "ak_bud_aug": "сер",
  "ak_bud_sep": "вер",
  "ak_bud_oct": "жов",
  "ak_bud_nov": "лис",
  "ak_bud_dec": "гру",
  "ak_bud_low_2": "низький",
  "ak_bud_base_2": "базовий",
  "ak_bud_high_2": "високий",
  "ak_bud_january": "січень",
  "ak_bud_february": "лютий",
  "ak_bud_march": "березень",
  "ak_bud_april": "квітень",
  "ak_bud_may_2": "травень",
  "ak_bud_june": "червень",
  "ak_bud_july": "липень",
  "ak_bud_august": "серпень",
  "ak_bud_september": "вересень",
  "ak_bud_october": "жовтень",
  "ak_bud_november": "листопад",
  "ak_bud_december": "грудень",
  "ak_bud_year_http": "рік: HTTP {{s}}",
  "ak_bud_month_http": "місяць: HTTP {{s}}",
  "ak_bud_budget_year": "бюджетний рік {{p}}",
  "ak_bud_budget_year_2": "бюджетний рік",
  "ak_bud_price_scenario": "сценарій цін: {{s}}",
  "ak_bud_approved": "затверджена",
  "ak_bud_reference_form": "еталонна форма",
  "ak_bud_failed_to_load_the_budget": "Не вдалося завантажити бюджет: {{err}}",
  "ak_bud_actual_mn_days": "факт {{r}} млн · {{d}} діб",
  "ak_bud_incl_bess_mn": "у т.ч. УЗЕ {{v}} млн",
  "ak_bud_plan": "план",
  "ak_bud_margin": "маржа {{v}}",
  "ak_bud_actual_mwh": "факт {{v}} МВт·год",
  "ak_bud_avg_price_uah_mwh": "сер. ціна {{v}} грн/МВт·год",
  "ak_bud_vs_budget": "{{v}} до бюджету",
  "ak_bud_the_monthly_breakdown_has_been_entered": "Помісячну розкладку заведено лише для базового сценарію. Підсумки року за всіма трьома є у «Параметрах» вкладки «Рік».",
  "ak_bud_version": "версія {{st}} · {{src}}",
  "ak_bud_uah_excl_vat": "грн без ПДВ · {{f}}",
  "ak_bud_approved_2": "затверджено: {{by}}",
  "ak_bud_fixed_directory_items_against_actual_a": "Фіксовані статті довідника проти факту нарахувань і оплат; різниця — кредиторська заборгованість.",
  "ak_bud_the_payment_calendar_is_calculated_fro": "Календар платежів рахується з затвердженого річного бюджету — його ще немає для цієї станції, або дані завантажуються.",
  "ak_bud_failed_to_load": "не вдалося завантажити",
  "ak_bud_no_station_selected": "станція не обрана",
  "ak_bud_budget": "Бюджет",
  "ak_bud_loading": "Завантаження…",
  "ak_bud_there_is_no_approved_budget_version_fo": "Для цієї станції затвердженої версії бюджету ще немає. Пілот модуля — СЕС Лучки.",
  "ak_bud_revenue": "Виручка",
  "ak_bud_uah_mn": "млн грн",
  "ak_bud_grid_export": "Відпуск у мережу",
  "ak_bud_mwh": "МВт·год",
  "ak_bud_debt_service": "Обслуговування боргу",
  "ak_bud_interest_fees_principal": "проценти, комісії, тіло",
  "ak_bud_month_forecast": "Прогноз місяця",
  "ak_bud_actual_plan_for_the_remaining_days": "факт + план решти діб",
  "ak_bud_month_summary": "Зведення місяця",
  "ak_bud_daily_profile_prices_and_release_plan": "Профіль доби: ціни та план відпуску",
  "ak_bud_plan_vs_actual_by_day": "План-факт по днях",
  "ak_bud_costs_accrued_and_paid": "Витрати: нараховано та оплачено",
  "ak_bud_requires_access_to_accounting": "потребує доступу до бухгалтерії",
  "ak_bud_by_month": "Помісячно",
  "ak_bud_break_even_and_dscr": "Безбитковість і DSCR",
  "ak_bud_fixed_costs_1_5_5_variable": "постійні витрати / (1 − 5,5% змінних)",
  "ak_bud_loan": "Кредит",
  "ak_bud_see_the_version_note_below": "див. примітку версії нижче",
  "ak_bud_parameters": "Параметри",
  "ak_bud_pending_approval": "на затвердженні",
  "ak_bud_superseded": "замінена",
  "ak_bud_draft_t_5": "чернетка T−5",
  "ak_bud_final_t_1": "фінал T−1",
  "ak_bud_reference_import": "імпорт еталона",
  "ak_bud_failed_to_approve_http": "Не вдалося затвердити: HTTP {{s}}",
  "ak_bud_created": "створено {{d}}",
  "ak_bud_approved_by": " · затвердив {{by}} {{d}}",
  "ak_bud_scenario": " · сценарій {{s}}",
  "ak_bud_vs_previous": "проти попередньої ({{s}}):",
  "ak_bud_revenue_2": "виручка",
  "ak_bud_mn": "млн",
  "ak_bud_export": "відпуск",
  "ak_bud_stress": "стрес",
  "ak_bud_approve": "Затвердити",
  "ak_bud_inactive": "не діє",
  "ak_bud_spec_a2_rules_draft_t_5_final_t_1_at_0": "Регламент ТЗ A2: чернетка T−5, фінал T−1 о 09:00, автоутвердження о 12:00, якщо фінвідділ не затвердив вручну. Механізм автоутвердження реалізовано, але за розписанням ще не запущений — це рішення власника процесу.",
  "ak_bud_failed_to_approve_the_version": "Не вдалося затвердити версію",
  "ak_bud_auto": " (авто)",
  "ak_bud_monthly_budget_versions": "Версії бюджету місяця",
  "ak_bud_versions_are_not_edited_each_revision": "версії не правляться — кожна редакція окремим рядком",
  "ak_bud_no_versions_for_the_month_yet_generate": "Версій місяця ще немає. Згенеруйте чернетку або фінал кнопкою в шапці.",
  "ak_bud_approve_this_version_the_other_version": "Затвердити цю версію; решта версій періоду стануть заміненими",
  "ak_bud_indexation_from": "Індексація {{p}} з {{d}}",
  "ak_bud_metric": "Показник",
  "ak_bud_grid_export_mwh": "Відпуск у мережу, МВт·год",
  "ak_bud_average_sale_price_uah_mwh": "Середня ціна продажу, грн/МВт·год",
  "ak_bud_revenue_uah_mn": "Виручка, млн грн",
  "ak_bud_incl_bess_effect": "у т.ч. ефект УЗЕ",
  "ak_bud_variable_costs_uah_mn": "Змінні витрати, млн грн",
  "ak_bud_fixed_opex_uah_mn": "Фіксовані OPEX, млн грн",
  "ak_bud_ebitda_uah_mn": "EBITDA, млн грн",
  "ak_bud_finance_costs_uah_mn": "Фінансові, млн грн",
  "ak_bud_pre_tax_profit_uah_mn": "Прибуток до податку, млн грн",
  "ak_bud_income_tax_uah_mn": "Податок на прибуток, млн грн",
  "ak_bud_net_profit_uah_mn": "Чистий прибуток, млн грн",
  "ak_bud_loan_principal_repayment_uah_mn": "Погашення тіла кредиту, млн грн",
  "ak_bud_cash_flow_after_repayment_uah_mn": "Потік після погашення, млн грн",
  "ak_bud_cumulative_uah_mn": "Наростаючим підсумком, млн грн",
  "ak_bud_fixed_mn": "Постійні, млн",
  "ak_bud_break_even_revenue_mn": "БУ-виручка, млн",
  "ak_bud_revenue_plan_mn": "План виручки, млн",
  "ak_bud_safety_margin": "Запас прочності",
  "ak_bud_break_even_price_base": "БУ-ціна BASE",
  "ak_bud_break_even_export_mwh": "БУ-відпуск, МВт·год",
  "ak_bud_cash_break_even_mn": "Кассова БУ, млн",
  "ak_bud_debt_service_coverage_dscr_ebitda_inte": "Покриття обслуговування боргу (DSCR = EBITDA / проценти + комісія + РКО + тіло)",
  "ak_bud_balance_eur": "Залишок, EUR",
  "ak_bud_fx_rate": "Курс",
  "ak_bud_interest_mn": "Проценти, млн",
  "ak_bud_principal_eur": "Тіло, EUR",
  "ak_bud_principal_uah_mn": "Тіло, млн грн",
  "ak_bud_fee_k": "Комісія, тис",
  "ak_bud_account_servicing_k": "РКО, тис",
  "ak_bud_debt_service_mn": "Обслуговування, млн",
  "ak_bud_version_assumptions": "Допущення версії",
  "ak_bud_fixed_opex_items_uah_month": "Фіксовані статті OPEX, грн/місяць",
  "ak_bud_year_by_price_scenario_uah_mn": "Рік за сценаріями цін, млн грн",
};

export default translations;
